import React from 'react';
import entities from '../../utils/entities';
import { Button,Row,Col } from 'reactstrap';
import Editor from '../Models/Editor';
import { Route, Switch, useHistory } from 'react-router-dom';
import { FormValue } from '../Form/FormLabel';
import { useAuth } from '../../Services/AuthContext';
const SupplierDetail = ({ index, route, supplier }) => {
    const { id, companyName, companyPhone, email } = supplier ? supplier : {};
    const history = useHistory();
    const [auth] = useAuth(); 
    //<StringSelector id='catering' label="Catering" list={charterTypes?.catering} />
    //  <BooleanInput id='shared' label='Shared' />
    const setItemId = (id) => id ? history.push(route + "/supplier/" + id) : history.push(route);
    return auth.canViewSupplierInfo || auth.role === 'Admin' ? <React.Fragment>
        {supplier ? <Col>
            <Row>
                <FormValue><Button size="sm" onClick={() => setItemId(id)}>Supplier ({supplier.status})</Button></FormValue>
            </Row>
            <Row>
                <FormValue>{companyName}</FormValue>
            </Row>
            <Row>
                <FormValue>{email}</FormValue>
            </Row>
            <Row>
                <FormValue>{companyPhone}</FormValue>
            </Row>
            <Switch>
                {!index ? <Route path={route + '/supplier/:supplierId/:activeKey'} render={({ match }) => <Editor route={route + '/supplier'} entity={entities.supplier} itemId={match.params.supplierId} editorClosed={() => setItemId()} />} /> : null}
                {!index ? <Route path={route + '/supplier/:supplierId'} render={({ match }) => <Editor route={route + '/supplier'} entity={entities.supplier} itemId={match.params.supplierId} editorClosed={() => setItemId()} />} /> : null}
            </Switch>
        </Col> : null}


    </React.Fragment> : null;

};

export default SupplierDetail;